const amendmentTextSuffix = '(Contrato-A)';
const contractTextSuffix = '(Contrato)';

const contractDocumentTypes = {
  unset: 0,
  certificadoColegiacion: 7,
  copiaPEI: 22,
  contratoFirmado: 25,
  minutaCompu: 27,
  cartaAprobaciónRemedio: 28,
  peiEnmiendasCorrespondientes: 33,
  minutaPEIEvidenciaRecomendacionesAEE: 35,
  otros: 37,
  planIntervencion: 39,
  informeProgreso: 40,
  documentoEvaluacion: 45,
  certificaciónAutorizaciónFirma: 47,
  supplierChangeRequest: 49,
  documentoColegiacion: 60,
  autorizaciónFirma: 63,
  certificadoOColegiacion: 73,
  licenciaCertificadoProfesional: 92,
  certificaciónPRBackgroundCheckProgram: 93,
  permisoÚnico: 97,
  licenciaProfesionalEnfermera: 102,
  ProfileProvider: 90,
};

const contractDocumentTypesString = {
  22: 'Copia del PEI',
  25: 'Contrato Firmado',
  27: 'Minuta de COMPU',
  28: 'Carta de Aprobación del Remedio',
  33: 'PEI con las Enmiendas correspondientes',
  35: 'Minuta y PEI que evidencia las recomendaciones AEE',
  37: 'Otros',
  39: 'Plan de Intervención',
  40: 'Informe de Progreso',
  45: 'Certificación de Evaluación',
  47: 'Certificación de Autorización de Firma',
  49: 'Solicitud de Cambio de Suplidor',
  63: 'Autorización de Firma',
};

const getContractOrAmendentName = (text, isAmendment = false) => {
  return isAmendment
    ? `${text} ${amendmentTextSuffix}`
    : `${text} ${contractTextSuffix}`;
};

const getContractDocumentMask = (contractTypeId, isAmendment = false) => {
  let contractName = '';

  switch (contractTypeId) {
    case contractDocumentTypes.autorizaciónFirma:
    case contractDocumentTypes.certificaciónAutorizaciónFirma:
    case contractDocumentTypes.otros:
    default:
      return contractDocumentTypesString[contractTypeId];

    case contractDocumentTypes.contratoFirmado:
    case contractDocumentTypes.minutaCompu:
    case contractDocumentTypes.cartaAprobaciónRemedio:
    case contractDocumentTypes.peiEnmiendasCorrespondientes:
    case contractDocumentTypes.minutaPEIEvidenciaRecomendacionesAEE:
    case contractDocumentTypes.planIntervencion:
    case contractDocumentTypes.informeProgreso:
    case contractDocumentTypes.copiaPEI:
    case contractDocumentTypes.supplierChangeRequest:
      contractName = contractDocumentTypesString[contractTypeId];
  }

  return getContractOrAmendentName(contractName, isAmendment);
};

export {
  contractDocumentTypes,
  contractDocumentTypesString,
  getContractDocumentMask,
};
